<template>
    <div>
      <div v-for="option in reversedOptions" :key="option.value">
        <b-radio
            :value="value"
            type="is-teal"
            size="is-small"
            :native-value="option.value"
            @input="handleInput"
        >
          {{ option.label }}
        </b-radio>
        <br />
      </div>
    </div>
</template>

<script>
    export default {
      name: 'RatingSelectionRadioButtons',
      data() {
          return {
            options: [
              {
                value: 50,
                label: '5+',
              },
              {
                value: 60,
                label: '6+',
              },
              {
                value: 70,
                label: '7+',
              },
              {
                value: 80,
                label: '8+',
              },
              {
                value: 90,
                label: '9+',
              },
            ],
          }
      },
      props: {
        highestRating: Number,
        value: {},
        size: {
          type: String,
          default: 'is-small'
        }
      },
      computed: {
        reversedOptions(){
          let reversedOptions = this.options.slice().reverse();
          return reversedOptions;
        }
      },
      methods: {
        handleInput (val) {
          //// console.log('value', val);
          this.$emit('input', val);
        }
      },
      watch:{
        value: function(){
          this.$emit('input', this.value)
        }
      }
    }
</script>

<style lang="scss" scoped>
.pding {
  padding: 10px;
}

.label {
  &.is-required {
    &:before {
      content: "*";
      color: red;
      margin-right: 6px;
    }
  }
}


</style>
